<template>
  <div>
    <v-switch
      :append-icon="appendIcon"
      :prepend-icon="prependIcon"
      :background-color="background"
      :color="color"
      :dark="dark"
      :dense="dense"
      :disabled="disabled"
      :flat="flat"
      :inset="inset"
      :label="label"
      v-model="switchState"
      @change="handleChange"
      @click:append="appendClick"
      @click:prepend="prependClick"
    >
      <template #label v-if="fieldlabel">
        {{ full_label }}
      </template>
    </v-switch>
  </div>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { ref, computed, onMounted } from "vue";

  // Define the properties
  const props = defineProps({
    config: { type: Object, required: false },
    label: { type: String, required: false },
    value: {type: [Boolean], require: true}
  });

  // Define the switch state
  let switchState = ref(false);

  // Load the initial value into data
  onMounted(() => {
    switchState.value = props?.value
  })

  // Define emits
  const emit = defineEmits(["update:clicked", "input"]);

  // User Action Functions
  const handleChange = () =>
    console.log(`Switch State = `, switchState)
    emit("input", switchState.value);
  const appendClick = () => emit("update:clicked", { append: true });
  const prependClick = () => emit("update:clicked", { prepend: true });

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  // Visual settings
  const appendIcon = computed(() => propCheck("append_icon", undefined));
  const prependIcon = computed(() => propCheck("pre_icon", undefined));
  const background = computed(() => propCheck("background", undefined));
  const color = computed(() => propCheck("color", undefined));
  const dense = computed(() => propCheck("dense", false));
  const disabled = computed(() => propCheck("disable", false));
  const flat = computed(() => propCheck("flat", false));
  const inset = computed(() => propCheck("inset", false));
  const fieldlabel = computed(() => propCheck("label", false));
  const dark = computed(() => propCheck("dark", false))
  
</script>